import { StandardsModalViewMoreButton } from "./StandardsModalViewMoreButton";

export { StandardsModalViewMoreButton };
